<script setup>
import { computed } from 'vue';
import { Toast, useFilterSidePanel } from '@dashhudson/dashing-ui';

const { visible } = useFilterSidePanel();

const leftPadding = computed(() => (visible.value ? undefined : '84px'));
</script>

<template>
  <Toast :left-padding="leftPadding" />
</template>
